import { render, staticRenderFns } from "./WidgetMini.vue?vue&type=template&id=6b6f4ee9&scoped=true&"
import script from "./WidgetMini.vue?vue&type=script&lang=js&"
export * from "./WidgetMini.vue?vue&type=script&lang=js&"
import style0 from "./WidgetMini.vue?vue&type=style&index=0&id=6b6f4ee9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f4ee9",
  null
  
)

export default component.exports